<div class="root-container">
  <div class="root-body">
    <router-outlet style="display: none"></router-outlet>
  </div>
</div>
